import React from 'react';
import { ListGroup } from 'react-bootstrap';
import { ProgramRequestItem } from './ProgramRequestItem';

import './program-group-item.css';

export function ProgramGroupItem(props) {
    const { item: groupItem } = props;
    return (
        <ListGroup.Item className="py-0 pr-0 pl-5">
            <ListGroup variant="flush">
                <ListGroup.Item className="program-group-item-header">{groupItem.title}</ListGroup.Item>
                {groupItem.items.map((reqItem) => (
                    <ProgramRequestItem key={reqItem.id} item={reqItem} inGroup />
                ))}
            </ListGroup>
        </ListGroup.Item>
    );
}
